import { useContext } from 'react';
import { GlobalVarsContext } from '../../context/GlobalVarsProvider';

export const useGlobalVars = () => {
    const { getGlobalVar, setGlobalVar, resetGlobalVar } = useContext(GlobalVarsContext);

    return { getGlobalVar, setGlobalVar, resetGlobalVar };
};
